export const ENV_CFG = process.env.REACT_APP_ENV_CFG || "dev";
